export default __webpack_public_path__ + "static/media/screenPrinting.dc3dcb16.svg";